import { render } from "./ZoomOutIcon.vue?vue&type=template&id=6d4fceea"
import script from "./ZoomOutIcon.vue?vue&type=script&lang=js"
export * from "./ZoomOutIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__